// extracted by mini-css-extract-plugin
module.exports = {"container":"topMatchList__container___dZ7O6","is-visible":"topMatchList__is-visible___1OJqk","widget-wrapper":"topMatchList__widget-wrapper___1EBlL"};